import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { X, Bike, Loader2 } from "lucide-react";

export const TestRideModal = ({ product, onClose }) => {
  const [form, setForm] = useState({ name: "", phone: "", preferred_date: "", note: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (form.name.length < 2 || form.phone.length < 7 || !form.preferred_date)
      return toast.error("Name, phone and a preferred day are required");
    setBusy(true);
    try {
      await api.post("/test-rides", { ...form, product_id: product.id });
      setDone(true);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't send that — call us at (616) 410-0158");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center p-4" data-testid="testride-modal">
      <div className="bg-white w-full max-w-md rounded-xl overflow-hidden">
        <div className="bg-[#0A1C40] text-white px-5 py-4 flex items-center justify-between">
          <div className="font-display font-black text-lg flex items-center gap-2">
            <Bike className="w-5 h-5 text-[#FFC220]" /> Book a free test ride
          </div>
          <button onClick={onClose} data-testid="testride-close" aria-label="Close">
            <X className="w-5 h-5 opacity-70 hover:opacity-100" />
          </button>
        </div>
        {done ? (
          <div className="p-6 text-center" data-testid="testride-success">
            <div className="text-3xl">🎉</div>
            <h3 className="font-black text-[#0A1C40] text-lg mt-2">Request sent!</h3>
            <p className="text-sm text-gray-600 mt-2">
              We'll call or text you shortly to confirm a time for the <b>{product.name.split(" — ")[0]}</b>.
              Showroom: 88 54th St SW Ste 103, Grand Rapids, MI.
            </p>
            <button onClick={onClose} className="btn-primary mt-4 w-full" data-testid="testride-done-btn">Done</button>
          </div>
        ) : (
          <div className="p-5 space-y-3">
            <p className="text-xs text-gray-600">
              Ride the <b>{product.name.split(" — ")[0]}</b> at our Grand Rapids, MI showroom — no purchase needed.
            </p>
            <input className="input-base" placeholder="Your name" value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="testride-name" />
            <input className="input-base" type="tel" placeholder="Phone number" value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="testride-phone" />
            <input className="input-base" type="date" min={new Date().toISOString().slice(0, 10)}
              value={form.preferred_date}
              onChange={(e) => setForm({ ...form, preferred_date: e.target.value })} data-testid="testride-date" />
            <input className="input-base" placeholder="Anything we should know? (optional)" value={form.note}
              onChange={(e) => setForm({ ...form, note: e.target.value })} data-testid="testride-note" />
            <button onClick={submit} disabled={busy}
              className="btn-gold w-full inline-flex items-center justify-center gap-2" data-testid="testride-submit">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />} Request my test ride
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
